
export default function Testimonial() {
  return (
    <section className="bg-[#E2D9CA] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-black rounded-full"></span>
              <span className="text-sm uppercase tracking-wider text-[#936A0B] font-medium">
                TESTIMONIALS
              </span>
            </div>

            <div className="relative">
              <span className="absolute -left-4 -top-4 text-8xl text-[#EB9830] font-serif opacity-50">
                &ldquo;
              </span>
              <p className="text-5xl font-serif text-[#574407] leading-tight pl-8">
                The party bags were a huge hit! Every child left with the biggest smile
              </p>
            </div>

            <div className="flex items-center gap-3 pl-8">
              <span className="text-lg font-bold text-[#574407]">Amina Okafor</span>
              <div className="flex items-center gap-1.5 bg-green-100 px-3 py-1 rounded-full">
                <i className="ri-star-fill text-green-600 text-sm"></i>
                <span className="text-sm text-green-700 font-medium">Verified Buyer</span>
              </div>
            </div>

            <div className="pl-8 pt-4 border-t border-[#574407]/10 mt-4">
              <div className="relative">
                <span className="absolute -left-4 -top-2 text-5xl text-[#EB9830] font-serif opacity-30">
                  &ldquo;
                </span>
                <p className="text-2xl font-serif text-[#574407]/80 leading-snug pl-4">
                  ABEXIA dresses make me feel confident and elegant every single day
                </p>
              </div>
              <div className="flex items-center gap-3 pl-4 mt-4">
                <span className="text-base font-bold text-[#574407]">Sarah Mitchell</span>
                <div className="flex items-center gap-1.5 bg-green-100 px-3 py-1 rounded-full">
                  <i className="ri-star-fill text-green-600 text-sm"></i>
                  <span className="text-sm text-green-700 font-medium">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-3xl overflow-hidden shadow-xl w-full h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/5be28ccd03cd65c7d6e35f14f8fb79a4.jpg"
                alt="Customer Testimonial - ABEXIA"
                title="ABEXIA Customer Review"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
